import React from 'react';
import { DataTable, type TableColumn } from '@/src/ui';
import { ReportHeaderStyle, ReportCellStyle } from '@/src/utils';
import type { ClassFullDTO } from '../models/classDTOs';

interface ClassRosterTableProps {
    classDetails: ClassFullDTO | null;
}

const ClassRosterTable: React.FC<ClassRosterTableProps> = ({ classDetails }) => {
    if (!classDetails) return null;

    const columns: TableColumn[] = [
        {
            dataKey: 'fName',
            header: 'First Name',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
        },
        {
            dataKey: 'lName',
            header: 'Last Name',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
        },
        {
            dataKey: 'email',
            header: 'Email',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
        },
        {
            dataKey: 'username',
            header: 'Username',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
        },
    ];

    return (
        <div style={{ marginTop: 32 }}>
            <div
                style={{
                    fontFamily: 'Verdana, Geneva, sans-serif',
                    fontWeight: 500,
                    fontSize: '15px',
                    marginBottom: 4,
                }}
            >
                <span style={{ color: 'var(--pm-primary)' }}>Class Name:</span>{' '}
                {classDetails.className}
                <br />
                <span style={{ color: 'var(--pm-primary)' }}>School Year:</span>{' '}
                {classDetails.schoolYear}
            </div>
            <DataTable
                data={classDetails.assignedStudents}
                columns={columns}
                tableName="Class Roster"
                alternatingRowColor
                defaultSortColumn="fName"
                defaultSortDirection="asc"
            />
        </div>
    );
};

export default ClassRosterTable;
